import {
    clearFeedback,
    removeFeedback,
    showActionFeedback,
    showErrorFeedback,
    showReactActionFeedback,
    showReactErrorFeedback,
    showReactWarningFeedback,
    showWarningFeedback,
} from "~/sharedComponents/feedback/helper";
export { SavingNotifier, withSavingNotifier, withPromiseNotifier, notificationStates } from "./SavingNotifier";

export { showReactActionFeedback, showReactErrorFeedback, showReactWarningFeedback };
export const showFeedback = {
    action: showActionFeedback,
    warning: showWarningFeedback,
    error: showErrorFeedback,
    clear: clearFeedback,
    remove: removeFeedback,
};

export { Feedback } from "./Feedback";
